import { Component, EventEmitter, OnInit, Output, ViewChild } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { LazyLoadEvent } from 'primeng/api';
import { LookupService } from 'projects/shared/core/services/lookup.service';
import { BaseViewComponent } from 'projects/shared/core/interfaces/baseViewComponent';
import { ToastService } from 'projects/shared/core/services/toast.service';
import { SearchAirportComponent } from '../../../../../../shared/ui-rms/components/search-airport/search-airport.component';
import { AirportService } from '../../../../../../api/services/airport.service';
import { AirportModel } from '../../../../../../api/models/airport-model';
import { FindFilter } from '../../../../../../api/models/find-filter';
import { StateNameModel } from 'projects/rms/app/api/models/state-name-model';
import { ResponderProfileService } from "../../../shared/services/responder-profile.service";
import { ResponderProfileAirportsService } from '../../../shared/services/responder-profile-airports.service';


@Component({
  selector: 'search-airports-modal',
  templateUrl: './search-airports-modal.component.html',
  styleUrls: ['./search-airports-modal.component.css']
})
export class SearchAirportsModalComponent extends BaseViewComponent implements OnInit {
  @ViewChild(SearchAirportComponent) searchAirport: SearchAirportComponent;

  private _itemList$: BehaviorSubject<AirportModel[]> = new BehaviorSubject<AirportModel[]>([]);
  get itemList$() {
    return this._itemList$.asObservable();
  }
  get itemList() {
    return this._itemList$.value;
  }
  
  @Output() cancel = new EventEmitter<boolean>();
  @Output() selection = new EventEmitter<AirportModel>();

  states: StateNameModel[];

  selectedItem: AirportModel;
  filter: FindFilter;
  searchKeyValues: any = {};
  firstItem: number = 0;
  count: number = 0;
  modelError="";
  columns: any[] = [
    { header: "Airport", field: "airportName" },
    { header: "IATA Code", field: "iataCode" },
    { header: "City", field: "city" },
    { header: "State", field: "state" }
  ];

  constructor(
    private responderProfileAirportsService: ResponderProfileAirportsService,
    private toastService: ToastService,
    lookupService: LookupService) {
    super(lookupService);
    responderProfileAirportsService.loadStates().then((data) => this.states = data);
  }

  ngOnInit() {
    this.searchKeyValues = {"Active": "true"};
  }

  onCancelClick() {
    this.cancel.emit(false);
  }

  onReloadList(event: LazyLoadEvent) {
    let sortField = "";
    switch (event.sortField) {
      case "airportName":
        sortField = "AirportName";
        break;
      case "iataCode":
        sortField = "IATACode";
        break;
      case "city":
        sortField = "City";
        break;
      case "state":
        sortField = "State";
        break;
    }

    this.firstItem = event.first;
    let pageNumber = this.firstItem / event.rows;
    
    this.filter = Object.assign({}, {
      findKeys: this.searchKeyValues,
      pagingInfo: {
        "pageNumber": pageNumber,
        "pageSize": event.rows
      },
      sortInfos: [
        {
          "columnName": sortField,
          "isDescending": event.sortOrder === -1 ? true : false
        }
      ] 
    });
    this.getActiveData(false);
  }
  
  onSearch(event) {
    if (event["AirportName"] != this.filter.findKeys["AirportName"] ||
        event["IATACode"] != this.filter.findKeys["IATACode"] ||
        event["City"] != this.filter.findKeys["City"] ||
        event["State"] != this.filter.findKeys["State"]) {
      this.firstItem = 0;
      this.filter.pagingInfo.pageNumber = 0;
    }
    this.searchKeyValues = Object.assign(this.searchKeyValues, event);
    this.filter.findKeys = this.searchKeyValues;
    this.getActiveData(true);
  }
  
  onSelectClick(event) {
    this.selection.emit(event);
  }

  private getActiveData(searching: boolean) {
    return this.responderProfileAirportsService.getActiveAirports(this.filter)
      .then((data) => { this._itemList$.next(data);
        this.count = data["TotalRecordCount"];
        if (searching) {
         this.searchAirport.onSearchComplete();
        };
        this.modelError = "";
      })
      .catch((error) => this.toastService.showError(error));
  }

}
